namespace $.$$ {

	$mol_style_define( $shm_dashboard_opencode_app, {
		flex: {
			grow: 1,
			shrink: 1,
		},
		minWidth: 0,
		width: '100%',
		height: '100%',
		minHeight: 0,

		Chat_page: {
			flex: {
				basis: '100%',
				grow: 1,
				shrink: 1,
			},
			width: '100%',
			minWidth: 0,
		},
	} )

}
